import { AssignedShipTo, DeliveryAddress, GroupedAvailableShipTos, OrgCustomerShipToAssignment } from '../../../core/model';

export function getAvailableShipToUniqueId(availableShipTo: AssignedShipTo): string {
  return availableShipTo.soldTo.uid + '-' + availableShipTo.shipTo.id;
}

export function convertToAssignedShipTo(
  groupedAvailableShipTos: GroupedAvailableShipTos,
  shipTo: DeliveryAddress
): AssignedShipTo {
  return { soldTo: groupedAvailableShipTos.soldTo, shipTo: shipTo } as AssignedShipTo;
}

export function convertToOrgCustomerShipToAssignment(availableShipTos: AssignedShipTo[]): OrgCustomerShipToAssignment {
  const groupedAvailableShipTosMap = convertToGroupedAvailableShipTosMap(availableShipTos);

  return {
    assignedShipTos: Array.from(groupedAvailableShipTosMap, ([key, value]) => ({
      key,
      value: value.shipTos.map((shipTo) => shipTo.id),
    })),
  };
}

/**
 * Converts list of availableShipTos to Map of GroupedAvailableShipTos
 * @param availableShipTos
 * @returns map with key-value pairs for each soldTo as on example below.
 * Key contains soldTo ID and value contains object of type GroupedAvailableShipTos with soldTo object and a list of shipTos for this soldTo.
 *  "key": "soldToUid",
    "value": {
        "soldTo": {
            "uid": "soldToUid",
            ...
        },
        "shipTos": [
            {
                "id": "shipToId",
               ...
            }
        ]
    }
 */
export function convertToGroupedAvailableShipTosMap(availableShipTos: AssignedShipTo[]): Map<string, GroupedAvailableShipTos> {
  return availableShipTos.reduce((acc, item) => {
    acc
      .set(item.soldTo.uid, acc.get(item.soldTo.uid) || ({ soldTo: item.soldTo, shipTos: [] } as GroupedAvailableShipTos))
      .get(item.soldTo.uid)
      .shipTos.push(item.shipTo);
    return acc;
  }, new Map());
}
